var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-page"},[_c('div',{staticClass:"top-title"},[_vm._v("AI隐患识别系统")]),_c('div',{staticClass:"text-content"},[_vm._v("\n    通过给摄像头配置AI算法，智能监管“人的不安全行为，物的不安全状态”，发现隐患后立即报警，报警信号同步推送至管理员；同时形成抓拍台账，保存于系统后台数据库。\n  ")]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/ai/1.jpg")}}),_c('img',{attrs:{"src":require("./img/ai/2.jpg")}})])])
}]

export { render, staticRenderFns }